import { render, staticRenderFns } from "./selectCurrency.vue?vue&type=template&id=6dc89a86"
import script from "./selectCurrency.vue?vue&type=script&lang=js"
export * from "./selectCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports